/* global jQuery COMPONENTS */

COMPONENTS.ComponentMarketSearch = (function ($) {
  function ComponentMarketSearch () {
    this.$component = $('[data-ecs-component="component-marketsearch"]')
    this.$marketSearch = this.$component.find('[data-ecs-element="market-search"]')
    this.$marketSearchSubmit = this.$marketSearch.find('[data-ecs-components-control="submit"]')
    this.$marketSearchSelect = this.$marketSearch.find('[data-ecs-components-control="nice-select"]')
  }

  ComponentMarketSearch.prototype.init = function () {
    const component = this

    // FIXME: Replaces form functionality with JS for a simple redirect instead of sending data via parameters
    component.$marketSearchSubmit.click(function (event) {
      event.preventDefault()
      var selected = $(component.$marketSearchSelect).find(':selected').data('ecs-components-link')
      window.location.href = selected
    })
  }

  return ComponentMarketSearch
})(jQuery)

document.addEventListener('components_init', function (e) {
  // Hook into the main components init
  COMPONENTS.ComponentMarketSearch = new COMPONENTS.ComponentMarketSearch()
  COMPONENTS.ComponentMarketSearch.init()
})
